export default "__VITE_ASSET__C0jSZHBv__"